<template>
  <a-modal
  centered
    v-model="visible"
    :footer="null"
    class="upgrade-tip-contenter"
    :afterClose="close"
    :destroyOnClose="true"
    key="loginFrm"
    :width="350"
  >
    <div
      class="title"
      v-html="title"
    ></div>

    <div
      class="content"
      v-if="tipType=='unexhi'"
    >
      <p>
        <span>尊敬的用户，您好！</span>
        <span>如需使用本功能请详询在线客服，谢谢！</span>
      </p>
      <a @click="openCustomerService">在线咨询
        <a-icon
          type="caret-right"
          style="transform: scale(0.7);"
        /></a>
    </div>
    <div
      class="content"
      v-if="tipType=='untimes'||tipType=='unstimes'"
    >
      <p>
        抱歉,本日{{ tipType=='untimes'&&'查询'||'搜索' }}数已用完
        <span style="color:#666;">明天再继续吧!</span>
      </p>
      <a @click="visible=false">我知道了
        <a-icon
          type="caret-right"
          style="transform: scale(0.7);"
        /></a>
    </div>
    <div
      class="content"
      v-if="tipType=='upgrade'||tipType=='supgrade'"
    >
      <p>
        抱歉, 当前无剩余{{ tipType=='upgrade'&&'可查看次数'||'可用搜索' }}次数!
        <span>是否需要升级权益？</span>
      </p>

      <div>
        <a href="/account/dashboard">升级权益
          <a-icon
            type="caret-right"
            style="transform: scale(0.7);"
          /></a>
        <a
          @click="visible=false"
          style="margin-left:20px;color:#999;"
        >忽略</a>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true
    };
  },
  computed: {
    title() {
      switch (this.tipType) {
        case "unexhi":
          return "操作提示";
        case "supgrade":
        case "upgrade":
          return "升级提示";
        case "untimes":
          return "查询提示";
        case "unstimes":
          return "搜索提示";
      }
    }
  },
  props: {
    close: Function,
    tipType: {
      required: true,
      type: String
    },
    accountInfo: {
      required: true,
      type: Object
    }
  },
  methods: {
    openCustomerService() {
      window.CustomerService && (location.href = window.CustomerService);
    }
  }
};
</script>
<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";
.upgrade-tip-contenter {
  .ant-modal-body {
    padding: 0;
  }
  .title {
    color: #333;
    width: 100%;
    height: 45px;
    padding: 5px 20px;
    font-size: 16px;
    line-height: 40px;
    background-color: #f3f3f3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .content {
    text-align: center;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    p {
      margin: 30px auto 25px;
      color: #ff6b6b;
      font-size: 20px;
      font-weight: bold;
      span {
        font-weight: normal;
        display: block;
        font-size: 16px;
        // color:#666;
      }
    }
    a {
      margin: 0 auto;
      margin-bottom: 20px;
      display: inline-block;
    }
  }
}
</style>
